import { ParsedContext } from '../model'
import { first, isUndefinedOrEmpty } from '@afterpay/utils/string'

interface LoggedContext extends ParsedContext {
  isUnsupportedBrowser: boolean
}

interface LoggedServerContext {
  referrer: string
  userAgent: string
  acceptLanguage: string
  localAddress: string
  remoteAddress: string
}

interface AnonymousErrorPayload {
  httpStatus?: string
  responseHeaders?: string
  internalErrorMessage?: string
  requestUrl?: string
  kasadaBlocked?: boolean
}

const getServerContextProps = (request, ua): LoggedServerContext => {
  const { referrer, headers, ip } = request
  return {
    referrer: referrer ?? '',
    userAgent: ua ?? 'unknown',
    acceptLanguage: headers.get('accept-language') ?? '',
    localAddress: ip,
    remoteAddress: first(headers.get('true-client-ip')) ?? '',
  }
}

const getParsedContext = (request, locale, unsupportedBrowser): LoggedContext => {
  const hasToken = request.nextUrl.searchParams.get('token') !== null
  const query = hasToken ? request.nextUrl.search : ''
  return {
    hasToken,
    locale,
    query,
    isUnsupportedBrowser: unsupportedBrowser,
  }
}

export const logContext = (request, locale, unsupportedBrowser, ua): void => {
  const loggedServerContext = getServerContextProps(request, ua)
  const parsedContext = getParsedContext(request, locale, unsupportedBrowser)

  console.log(
    JSON.stringify({
      parsedContext,
      serverContext: loggedServerContext,
    })
  )
}

const WHITELISTED_HEADERS = ['http_correlation_id', 'cf-ray']

const KASADA_RESPONSE_BODY_REGEX = /KPSDK/

/**
 * Gets a payload for Amplitude logging, based on errors most commonly associated
 * with login and lookup.
 * @param error
 * @returns void
 */
export const getAnonymousErrorPayload = (error?: any): AnonymousErrorPayload => {
  const axiosHeaders = Object.fromEntries(
    Object.entries(error?.responseHeaders ?? {}).map(([key, value]) => (WHITELISTED_HEADERS.includes(key.toLowerCase()) ? [key, value] : []))
  )

  const kasadaBlocked = KASADA_RESPONSE_BODY_REGEX.test(error?.responseData)

  return {
    httpStatus: error?.status,
    responseHeaders: JSON.stringify({ ...axiosHeaders }),
    internalErrorMessage: error?.message,
    requestUrl: error?.requestUrl,
    ...(!isUndefinedOrEmpty(error?.responseData) && { kasadaBlocked }),
  }
}
